'use strict';
import _ from "lodash";
import Backbone from 'backbone';

import template from './../templates/footer.ejs';
import BaseView from './../views/base';

import CSSView from './css';
var styleId;
import cssTemplate from './../templates/footer-css.ejs';

export default BaseView.extend({
    template: template,
    tagName: 'div',
    className: 'view-footer',
    /**
     * [initialize description]
     * @param  {[type]} options [description]
     * @return {[type]}         [description]
     */
    initialize: function (options) {
      styleId = this.className + _.uniqueId();
      this.$el.addClass(styleId);
      this.model = options.model;
      this.uid = options.uid;

      _.bindAll(this, 'render');
    },
    /**
     * [render description]
     * @return {[type]} [description]
     */
    render: function () {
      if (this.CSSView) {
        this.CSSView.remove();
      }
      
      this.CSSView = new CSSView({
        model: this.model.get('copy')['customizations'],
        namespace: '#' + this.model.get('uid') + ' .' + styleId,
        template: cssTemplate
      });
      Backbone.$('head').append(this.CSSView.render().$el);

      this.$el.html(this.template({ isOneTrustEnabled: this.model.get('isOneTrustEnabled') }));
      return this;
    }
});
